var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H6.40007C7.35486 1 8.27054 1.37929 8.94568 2.05443C9.62082 2.72957 10.0001 3.64525 10.0001 4.60004V17.2002C10.0001 16.4841 9.71564 15.7973 9.20929 15.291C8.70293 14.7846 8.01617 14.5002 7.30008 14.5002H1V1Z",
    stroke: "#389AF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 1H13.6C12.6453 1 11.7296 1.37929 11.0544 2.05443C10.3793 2.72957 10 3.64525 10 4.60004V17.2002C10 16.4841 10.2845 15.7973 10.7908 15.291C11.2972 14.7846 11.9839 14.5002 12.7 14.5002H19.0001V1Z",
    stroke: "#389AF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/journal.3a77d0c38a5660d0c61a1c020462e6a0.svg";
export { ForwardRef as ReactComponent };